<template>
    <div class="com-item title-module" :key="index">
        <div class="component person-nav">
            <div class="van-sticky" :style="{
                backgroundColor: modata.WContent.bgColor || 'transparent'
            }">
                <div class="title-module__inner">
                    <p
                        class="title-module__en"
                        v-if="modata.WContent.enTitle"
                        :style="{ color: modata.WContent.enColor || '#004ea2' }"
                    >
                        {{ modata.WContent.enTitle }}
                    </p>
                    <p
                        class="title-module__cn"
                        v-if="modata.WContent.cnTitle"
                        :style="{ color: modata.WContent.cnColor || '#262626' }"
                    >
                        {{ modata.WContent.cnTitle }}
                    </p>
                    <div
                        class="title-module__desc"
                        v-if="modata.WContent.describe"
                        v-html="modata.WContent.describe"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "title-module",
    components: {},
    props: {
        index: {
            type: Number
        },
        type: {
            type: String,
            default: 'preview'
        },
        isactive: {
            type: Boolean,
            default: false
        },
        phoneWidth: {
            type: Number,
            default: 1280
        },
        proportion: {
            type: Number,
            default: 1
        },
        modata: {
            type: Object,
            default: function() {
                return {
                    WName: 'title',
                    Title: '标题',
                    MID: 11,
                    WID: null,
                    ModuleName: 'title-module',
                    WContent: {}
                }
            }
        }
    },
    data() {
        return {}
    },
    mounted() {},
    beforeDestroy() {},
    methods: {},
    watch: {},
    filters: {}
}
</script>

<style scoped lang="scss">
p {
    margin: 0;
}
.title-module {
    .title-module__inner {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        align-items: center;
        text-align: center;
        width: 90%;
        max-width: 1600px;
        margin: 0 auto;
    }

    .title-module__en {
        line-height: normal;
        font-size: 20px;
        font-family: "pingfang medium", "PingFang SC", "Microsoft YaHei", sans-serif;
    }

    .title-module__cn {
        line-height: normal;
        font-size: 42px;
        font-family: "pingfang heavy", "PingFang SC", "Microsoft YaHei", sans-serif;
        margin-top: 10px;
    }

    .title-module__desc {
        font-size: 16px;
        color: #4e4e4e;
        line-height: 1.8;
        margin-top: 16px;

        ::v-deep p { margin: 0 0 8px; }
    }
}
</style>
